import React, { useState } from 'react';

const ReferralSection = () => {
  const [formData, setFormData] = useState({
    yourName: '',
    yourContact: '',
    friendName: '',
    friendContact: '',
  });

  const [hoveredInput, setHoveredInput] = useState(null);
  const [submitStatus, setSubmitStatus] = useState('idle');
  const [submitError, setSubmitError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitStatus === 'loading') return;
    setSubmitStatus('loading');
    setSubmitError('');

    try {
      const yourDigits = formData.yourContact.replace(/\D/g, '');
      const friendDigits = formData.friendContact.replace(/\D/g, '');
      const phone = yourDigits.length >= 10 ? yourDigits : friendDigits;

      if (phone.length < 10) {
        setSubmitError('Укажите корректный номер телефона');
        setSubmitStatus('idle');
        return;
      }

      const response = await fetch('https://leads.deshiki.ru/api/leads', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': '1seller-leads-2026-secure-key',
        },
        body: JSON.stringify({
          name: formData.yourName,
          phone: phone,
          messenger: formData.yourContact.startsWith('@') ? formData.yourContact : undefined,
          comment: `Партнёрская программа\nДруг: ${formData.friendName}\nКонтакт друга: ${formData.friendContact}`,
          source: window.location.hostname,
          pageUrl: window.location.pathname + '#referral',
        }),
      });

      if (!response.ok) throw new Error('HTTP ' + response.status);

      setSubmitStatus('success');
      setFormData({ yourName: '', yourContact: '', friendName: '', friendContact: '' });
      setTimeout(() => setSubmitStatus('idle'), 3000);
    } catch (error) {
      setSubmitStatus('error');
      setSubmitError('Ошибка отправки. Попробуйте позже.');
      console.error('Referral submit error:', error);
      setTimeout(() => { setSubmitStatus('idle'); setSubmitError(''); }, 5000);
    }
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const steps = [
    {
      number: '01',
      text: 'Оставьте контакт друга',
      icon: '/images/icons/card.webp',
    },
    {
      number: '02',
      text: 'Мы запускаем ему магазин',
      icon: '/images/icons/rocket.webp',
    },
    {
      number: '03',
      text: 'Вы получаете бонус',
      icon: '/images/icons/coins.webp',
    },
  ];

  return (
    <section
      id="referral"
      className="referral-section"
      style={{
        background: '#0F0F1A',
        padding: '100px 0',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Декоративные иконки на фоне */}
      <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none', zIndex: 0 }}>
        <img loading="lazy" src="/images/icons/coins.webp" alt="" className="referral-bg-icon referral-bg-1" />
        <img loading="lazy" src="/images/icons/star.webp" alt="" className="referral-bg-icon referral-bg-2" />
        <img loading="lazy" src="/images/icons/rocket.webp" alt="" className="referral-bg-icon referral-bg-3" />
        <img loading="lazy" src="/images/icons/wallet.webp" alt="" className="referral-bg-icon referral-bg-4" />
      </div>

      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 24px',
          position: 'relative',
          zIndex: 1,
        }}
      >
        <div
          className="referral-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 520px',
            gap: '80px',
            alignItems: 'center',
          }}
        >
          {/* Левая колонка - контент */}
          <div
            className="referral-left"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              minHeight: '680px',
            }}
          >
            {/* Плашка ПАРТНЁРСКАЯ ПРОГРАММА */}
            <div
              style={{
                display: 'inline-block',
                background: 'transparent',
                border: 'none',
                padding: 0,
                marginBottom: '24px',
              }}
            >
              <span
                style={{
                  fontSize: '14px',
                  fontWeight: 700,
                  color: '#FF8847',
                  textTransform: 'uppercase',
                  letterSpacing: '0.1em',
                }}
              >
                ПАРТНЁРСКАЯ ПРОГРАММА
              </span>
            </div>

            {/* Заголовок */}
            <h2
              className="referral-title"
              style={{
                fontSize: '52px',
                fontWeight: 900,
                color: '#FFFFFF',
                textTransform: 'none',
                lineHeight: 1.1,
                margin: '0 0 20px 0',
                letterSpacing: '-0.02em',
              }}
            >
              Приводите друзей —{' '}
              <span
                style={{
                  background: 'linear-gradient(90deg, #FFB847 0%, #FF8847 50%, #FF47A3 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                получайте бонусы
              </span>
            </h2>

            {/* Подзаголовок */}
            <p
              className="referral-subtitle"
              style={{
                fontSize: '24px',
                fontWeight: 400,
                color: 'rgba(255, 255, 255, 0.6)',
                margin: '0 0 36px 0',
                lineHeight: 1.4,
              }}
            >
              У вас есть друзья или коллеги, кому нужен KIT?
              <br />
              Рекомендуйте нас и зарабатывайте
            </p>

            {/* Сумма бонуса */}
            <div
              className="referral-bonus-card"
              style={{
                background: 'rgba(97, 66, 38, 0.4)',
                borderRadius: '24px',
                padding: '28px 40px',
                marginBottom: '40px',
                border: '1px solid rgba(255, 136, 71, 0.2)',
                display: 'inline-block',
                maxWidth: 'fit-content',
              }}
            >
              <span
                className="referral-bonus"
                style={{
                  fontSize: '72px',
                  fontWeight: 900,
                  background: 'linear-gradient(90deg, #FFD447 0%, #FF8847 25%, #FF5E47 50%, #FF47A3 75%, #B447FF 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  display: 'block',
                  lineHeight: 1,
                  marginBottom: '12px',
                  letterSpacing: '-0.02em',
                }}
              >
                до 50 000 ₽
              </span>
              <span
                style={{
                  fontSize: '22px',
                  fontWeight: 500,
                  color: 'rgba(255, 255, 255, 0.5)',
                }}
              >
                за каждого приведённого клиента
              </span>
            </div>

            {/* Шаги */}
            <div
              className="referral-steps"
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '24px',
                marginBottom: '32px',
                alignItems: 'flex-start',
              }}
            >
              {steps.map((step, index) => (
                <div
                  key={step.number}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    flex: '1',
                  }}
                >
                  <span
                    style={{
                      fontSize: '42px',
                      fontWeight: 900,
                      color: 'rgba(255, 255, 255, 0.08)',
                      lineHeight: 1,
                      letterSpacing: '-0.02em',
                      minWidth: '60px',
                    }}
                  >
                    {step.number}
                  </span>
                  <p
                    style={{
                      fontSize: '15px',
                      fontWeight: 500,
                      color: '#FFFFFF',
                      margin: 0,
                      lineHeight: 1.4,
                    }}
                  >
                    {step.text}
                  </p>
                </div>
              ))}
            </div>

            {/* Сноска */}
            <p
              style={{
                fontSize: '12px',
                fontWeight: 400,
                color: 'rgba(255, 255, 255, 0.3)',
                margin: 0,
                lineHeight: 1.5,
              }}
            >
              *Бонус выплачивается при достижении целевых показателей клиентом за первые 2 месяца работы
            </p>
          </div>

          {/* Правая колонка - форма */}
          <div
            className="referral-form"
            style={{
              background: '#25252D',
              borderRadius: '32px',
              padding: '48px',
              boxShadow: '0 24px 80px rgba(0, 0, 0, 0.4)',
              position: 'relative',
            }}
          >
            {/* 3D персонаж в правом верхнем углу */}
            <div
              style={{
                position: 'absolute',
                width: '140px',
                height: '140px',
                top: '-30px',
                right: '40px',
                background: 'linear-gradient(135deg, #B447FF 0%, #FF47A3 100%)',
                borderRadius: '50% 50% 40% 60%',
                filter: 'blur(20px)',
                opacity: 0.5,
                pointerEvents: 'none',
              }}
            />

            {/* Заголовок формы */}
            <h3
              style={{
                fontSize: '28px',
                fontWeight: 800,
                color: '#FFFFFF',
                margin: '0 0 8px 0',
                textTransform: 'none',
                letterSpacing: '-0.01em',
              }}
            >
              Рекомендовать друга
            </h3>
            <p
              style={{
                fontSize: '14px',
                fontWeight: 400,
                color: 'rgba(255, 255, 255, 0.5)',
                margin: '0 0 32px 0',
              }}
            >
              Заполните форму, и мы свяжемся с вашим другом
            </p>

            <form onSubmit={handleSubmit}>
              {/* Ваше имя */}
              <div style={{ marginBottom: '20px' }}>
                <label
                  style={{
                    display: 'block',
                    fontSize: '12px',
                    fontWeight: 600,
                    color: 'rgba(255, 255, 255, 0.7)',
                    textTransform: 'none',
                    letterSpacing: '0.01em',
                    marginBottom: '8px',
                  }}
                >
                  Ваше имя
                </label>
                <input
                  type="text"
                  placeholder="Как вас зовут?"
                  value={formData.yourName}
                  onChange={(e) => handleChange('yourName', e.target.value)}
                  onFocus={() => setHoveredInput('yourName')}
                  onBlur={() => setHoveredInput(null)}
                  required
                  style={{
                    width: '100%',
                    padding: '16px 20px',
                    fontSize: '15px',
                    fontWeight: 400,
                    color: '#FFFFFF',
                    background: hoveredInput === 'yourName' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(255, 255, 255, 0.05)',
                    border: hoveredInput === 'yourName' ? '2px solid rgba(255, 136, 71, 0.4)' : '2px solid transparent',
                    borderRadius: '14px',
                    outline: 'none',
                    transition: 'all 0.3s ease',
                    fontFamily: "'Inter', sans-serif",
                    boxShadow: 'none',
                  }}
                />
              </div>

              {/* Ваш контакт */}
              <div style={{ marginBottom: '20px' }}>
                <label
                  style={{
                    display: 'block',
                    fontSize: '12px',
                    fontWeight: 600,
                    color: 'rgba(255, 255, 255, 0.7)',
                    textTransform: 'none',
                    letterSpacing: '0.01em',
                    marginBottom: '8px',
                  }}
                >
                  Ваш телефон или Telegram
                </label>
                <input
                  type="text"
                  placeholder="+7 или @username"
                  value={formData.yourContact}
                  onChange={(e) => handleChange('yourContact', e.target.value)}
                  onFocus={() => setHoveredInput('yourContact')}
                  onBlur={() => setHoveredInput(null)}
                  required
                  style={{
                    width: '100%',
                    padding: '16px 20px',
                    fontSize: '15px',
                    fontWeight: 400,
                    color: '#FFFFFF',
                    background: hoveredInput === 'yourContact' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(255, 255, 255, 0.05)',
                    border: hoveredInput === 'yourContact' ? '2px solid rgba(255, 136, 71, 0.4)' : '2px solid transparent',
                    borderRadius: '14px',
                    outline: 'none',
                    transition: 'all 0.3s ease',
                    fontFamily: "'Inter', sans-serif",
                    boxShadow: 'none',
                  }}
                />
              </div>

              {/* Разделитель */}
              <div
                style={{
                  height: '1px',
                  background: 'linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.1) 50%, transparent 100%)',
                  margin: '28px 0',
                }}
              />

              {/* Имя друга */}
              <div style={{ marginBottom: '20px' }}>
                <label
                  style={{
                    display: 'block',
                    fontSize: '12px',
                    fontWeight: 600,
                    color: 'rgba(255, 255, 255, 0.7)',
                    textTransform: 'none',
                    letterSpacing: '0.01em',
                    marginBottom: '8px',
                  }}
                >
                  Имя друга
                </label>
                <input
                  type="text"
                  placeholder="Как зовут вашего друга?"
                  value={formData.friendName}
                  onChange={(e) => handleChange('friendName', e.target.value)}
                  onFocus={() => setHoveredInput('friendName')}
                  onBlur={() => setHoveredInput(null)}
                  required
                  style={{
                    width: '100%',
                    padding: '16px 20px',
                    fontSize: '15px',
                    fontWeight: 400,
                    color: '#FFFFFF',
                    background: hoveredInput === 'friendName' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(255, 255, 255, 0.05)',
                    border: hoveredInput === 'friendName' ? '2px solid rgba(255, 136, 71, 0.4)' : '2px solid transparent',
                    borderRadius: '14px',
                    outline: 'none',
                    transition: 'all 0.3s ease',
                    fontFamily: "'Inter', sans-serif",
                    boxShadow: 'none',
                  }}
                />
              </div>

              {/* Контакт друга */}
              <div style={{ marginBottom: '32px' }}>
                <label
                  style={{
                    display: 'block',
                    fontSize: '12px',
                    fontWeight: 600,
                    color: 'rgba(255, 255, 255, 0.7)',
                    textTransform: 'none',
                    letterSpacing: '0.01em',
                    marginBottom: '8px',
                  }}
                >
                  Контакт друга
                </label>
                <input
                  type="text"
                  placeholder="Телефон или Telegram друга"
                  value={formData.friendContact}
                  onChange={(e) => handleChange('friendContact', e.target.value)}
                  onFocus={() => setHoveredInput('friendContact')}
                  onBlur={() => setHoveredInput(null)}
                  required
                  style={{
                    width: '100%',
                    padding: '16px 20px',
                    fontSize: '15px',
                    fontWeight: 400,
                    color: '#FFFFFF',
                    background: hoveredInput === 'friendContact' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(255, 255, 255, 0.05)',
                    border: hoveredInput === 'friendContact' ? '2px solid rgba(255, 136, 71, 0.4)' : '2px solid transparent',
                    borderRadius: '14px',
                    outline: 'none',
                    transition: 'all 0.3s ease',
                    fontFamily: "'Inter', sans-serif",
                    boxShadow: 'none',
                  }}
                />
              </div>

              {/* Сообщения */}
              {submitError && (
                <div style={{ marginBottom: '16px', padding: '12px', background: 'rgba(239, 68, 68, 0.15)', border: '1px solid rgba(239, 68, 68, 0.3)', borderRadius: '12px', color: '#ef4444', fontSize: '14px', textAlign: 'center' }}>
                  {submitError}
                </div>
              )}
              {submitStatus === 'success' && (
                <div style={{ marginBottom: '16px', padding: '12px', background: 'rgba(34, 197, 94, 0.15)', border: '1px solid rgba(34, 197, 94, 0.3)', borderRadius: '12px', color: '#22c55e', fontSize: '14px', textAlign: 'center' }}>
                  Рекомендация отправлена!
                </div>
              )}

              {/* Кнопка отправки */}
              <button
                type="submit"
                disabled={submitStatus === 'loading'}
                style={{
                  width: '100%',
                  padding: '20px 24px',
                  fontSize: '15px',
                  fontWeight: 700,
                  color: '#FFFFFF',
                  background: submitStatus === 'loading' ? '#9ca3af' : 'linear-gradient(90deg, #FF8847 0%, #FF5E47 100%)',
                  border: 'none',
                  borderRadius: '16px',
                  cursor: submitStatus === 'loading' ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  textTransform: 'none',
                  letterSpacing: '0.01em',
                  fontFamily: "'Inter', sans-serif",
                  position: 'relative',
                  overflow: 'hidden',
                  boxShadow: submitStatus === 'loading' ? 'none' : '0 8px 24px rgba(255, 136, 71, 0.3)',
                }}
                onMouseEnter={(e) => {
                  if (submitStatus !== 'loading') {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 16px 32px rgba(255, 136, 71, 0.5)';
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = submitStatus === 'loading' ? 'none' : '0 8px 24px rgba(255, 136, 71, 0.3)';
                }}
              >
                {submitStatus === 'loading' ? 'Отправка...' : submitStatus === 'success' ? 'Отправлено!' : 'Отправить рекомендацию →'}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Стили */}
      <style>
        {`
          input::placeholder {
            color: rgba(255, 255, 255, 0.3);
          }

          .referral-form input {
            box-sizing: border-box !important;
          }

          /* Декоративные иконки на фоне */
          .referral-bg-icon {
            position: absolute;
            opacity: 0.05;
            filter: blur(1px) grayscale(0.3);
          }

          .referral-bg-1 {
            width: 100px;
            height: 100px;
            top: 8%;
            left: 5%;
            animation: floatReferral1 6s ease-in-out infinite;
          }

          .referral-bg-2 {
            width: 100px;
            height: 100px;
            top: 12%;
            right: 6%;
            animation: floatReferral2 7s ease-in-out infinite;
          }

          .referral-bg-3 {
            width: 100px;
            height: 100px;
            bottom: 15%;
            left: 7%;
            animation: floatReferral3 5.5s ease-in-out infinite;
          }

          .referral-bg-4 {
            width: 100px;
            height: 100px;
            bottom: 10%;
            right: 5%;
            animation: floatReferral4 6.5s ease-in-out infinite;
          }

          @keyframes floatReferral1 {
            0%, 100% { transform: translate(0, 0) rotate(-12deg); }
            50% { transform: translate(-10px, -15px) rotate(-12deg); }
          }

          @keyframes floatReferral2 {
            0%, 100% { transform: translate(0, 0) rotate(10deg); }
            50% { transform: translate(10px, -20px) rotate(10deg); }
          }

          @keyframes floatReferral3 {
            0%, 100% { transform: translate(0, 0) rotate(15deg); }
            50% { transform: translate(-15px, -10px) rotate(15deg); }
          }

          @keyframes floatReferral4 {
            0%, 100% { transform: translate(0, 0) rotate(-8deg); }
            50% { transform: translate(15px, -15px) rotate(-8deg); }
          }

          @media (max-width: 1024px) {
            .referral-grid { grid-template-columns: 1fr !important; gap: 40px !important; }
            .referral-left { min-height: auto !important; }
            .referral-form { padding: 32px !important; }
            .referral-bg-icon { display: none !important; }
          }

          @media (max-width: 768px) {
            .referral-section { padding: 50px 0 !important; }
            .referral-title { font-size: 32px !important; }
            .referral-subtitle { font-size: 18px !important; }
            .referral-bonus { font-size: 48px !important; }
            .referral-bonus-card { padding: 20px 24px !important; }
            .referral-steps { flex-direction: column !important; gap: 16px !important; }
            .referral-form { padding: 24px !important; border-radius: 20px !important; }
          }

          @media (max-width: 480px) {
            .referral-title { font-size: 26px !important; }
            .referral-bonus { font-size: 36px !important; }
            .referral-subtitle { font-size: 16px !important; }
          }
        `}
      </style>
    </section>
  );
};

export default ReferralSection;
